import React from "react";
import EditPublicationLine from "./EditPublicationLine";
import NewPublicationLine from "./NewPublicationLine";
import InlinePendingRow from "../../../profiles/InlinePendingRow";

// The publications table — one editable row per media job plus the "new record" affordance. Mirrors
// pr_profiles' EmploymentEditorActive, with Outlet in place of Company and no featured column (media jobs
// carry no `featured` flag).
function PublicationsEditorActive({
  publicationsState: { mediaJobs, addMediaJob, removeMediaJob, updateMediaJob, isUpdating },
}) {
  return (
    // Fixed layout + a colgroup bound the picker column to a fixed share of the table width. Without it
    // the outlet picker (react-select) auto-sizes its input to the typed text, so a long value grows the
    // cell and pushes the action buttons off-screen; fixed layout locks each column to its colgroup width
    // and clips the overflow inside the control instead. Every column carries an explicit percentage that
    // sums to 100%: a lone auto column does NOT absorb the leftover between the table's 100% width and the
    // sized columns under fixed layout — it collapses to ~0 and strands the surplus as dead space, which
    // squeezes the title down to one word per line and overlaps the headers. table-responsive lets a
    // narrow viewport scroll rather than crushing the date/action columns below the table's min-width.
    // (Same treatment as pr_profiles' EmploymentEditorActive.)
    <div className="table-responsive">
      <table className="table" style={{ tableLayout: "fixed", minWidth: "40rem" }}>
        <colgroup>
          <col style={{ width: "24%" }} />
          <col style={{ width: "28%" }} />
          <col style={{ width: "18%" }} />
          <col style={{ width: "18%" }} />
          <col style={{ width: "12%" }} />
        </colgroup>
        <thead>
          <tr>
            <th>Outlet</th>
            <th>Title</th>
            <th>From</th>
            <th>To</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {mediaJobs.map((line) => (
            <EditPublicationLine
              key={line.id}
              mediaJob={line}
              onChange={(updatedFields) => updateMediaJob(line.id, updatedFields)}
              onRemove={() => removeMediaJob(line.id)}
              disabled={isUpdating}
            />
          ))}
          <NewPublicationLine onNewMediaJob={addMediaJob} disabled={isUpdating} />
          <InlinePendingRow isPending={isUpdating} />
        </tbody>
      </table>
    </div>
  );
}

export default PublicationsEditorActive;
